<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { LinkTextPrimary } from '@shared/ui/links'

import DisciplineFilePackActions from './DisciplineFilePackActions.vue'
import { useTableDisciplineFiles } from '../model/table-discipline-files.hook'

defineOptions({
  name: 'TableDisciplineFiles',
})

const COLUMNS: readonly { title: string, className: string }[] = [
  { title: 'Date and time', className: 'table-discipline-files__date' },
  { title: 'Tutor', className: '' },
  { title: 'Type of file', className: 'table-discipline-files__type' },
  { title: 'File', className: '' },
  { title: '', className: 'table-discipline-files__actions' },
]

const {
  rows,
  isLoading,
  hasPacks,
  meta,
  perPageOptions,
  openPack,
  setChangePage,
  setChangePerPage,
} = useTableDisciplineFiles()
</script>

<template>
  <div class="table-discipline-files">
    <AppTable
      class="rounded-table"
      :meta="meta"
      :per-page-options="perPageOptions"
      :loading="isLoading"
      @change:page="setChangePage"
      @change:per-page="setChangePerPage"
    >
      <template #head>
        <AppTr>
          <AppTh
            v-for="column in COLUMNS"
            :key="column.title"
            :class="column.className"
          >
            <AppText
              name="body1-medium"
              color="slate-900"
            >
              {{ column.title }}
            </AppText>
          </AppTh>
        </AppTr>
      </template>

      <template
        v-if="hasPacks"
        #body
      >
        <AppTr
          v-for="row in rows"
          :key="row.pack.id"
        >
          <AppTd class="medium table-discipline-files__date">
            <AppText name="body1">
              {{ row.sentAt }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <LinkTextPrimary
              v-if="row.tutorUrl"
              :href="row.tutorUrl"
            >
              {{ row.tutorName }}
            </LinkTextPrimary>
            <AppText
              v-else
              name="body1"
              color="red-600"
            >
              Unassigned tutor
            </AppText>
          </AppTd>
          <AppTd class="medium table-discipline-files__type">
            <AppText name="body1">
              {{ row.categoryLabel }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <button
              v-if="row.filesText"
              type="button"
              class="table-discipline-files__open"
              @click="openPack(row.pack)"
            >
              <AppText
                name="body1"
                color="blue-700"
              >
                {{ row.filesText }}
              </AppText>
            </button>
            <AppText
              v-else
              name="body1"
              color="slate-500"
            >
              No files sent yet
            </AppText>
          </AppTd>
          <AppTd class="zero-padding table-discipline-files__actions">
            <DisciplineFilePackActions :pack="row.pack" />
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./TableDisciplineFiles.scss" />
